import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@chakra-ui/react'
import HTMLWrapper from 'lib/html-wrapper'

const BannerDescription = ({ data, theme, dataTestId, brandColor }) => {
  return (
    <Text
      color={theme.textColor}
      fontFamily='body'
      fontSize={`${theme.descriptionFontSize}em` || 'body'}
      fontWeight={theme.descriptionFontWeight || 'body'}
      lineHeight='tall'
      data-testid={dataTestId}
      className='banner-desc'
    >
      <HTMLWrapper html={data.description} />
      <style jsx global>{`
        :global(.banner-desc a) {
          color: ${brandColor} !important;
        }
        :global(.banner-desc ul) {
          padding-inline-start: 40px !important;
        }
      `}
      </style>
    </Text>
  )
}

BannerDescription.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string,
  brandColor: PropTypes.string.isRequired
}

export default BannerDescription
